import { Button, Dialog, DialogActions, DialogContent } from "@mui/material";
import { DialogHeader } from "../../../auth/components/PasswordRecoveryModal";
import { ClientPlan } from "../types";
import { ClientInfo } from "../pages/ClientDetails";

export default function PlanDetailsModal(props: {
  showPlanDetailsModal: boolean;
  setShowPlanDetailsModal: (value: boolean) => void;
  plan?: ClientPlan;
}) {
  const {
    showPlanDetailsModal: showAddItemModal,
    setShowPlanDetailsModal: setShowAddItemModal,
    plan,
  } = props;
  const onClose = () => setShowAddItemModal(false);
  return (
    <>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={showAddItemModal}
        maxWidth="xs"
        fullWidth
      >
        <DialogHeader id="customized-dialog-title" onClose={onClose}>
          {`Detalhes do plano ${plan?.name} `}
        </DialogHeader>
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
          dividers
        >
          <ClientInfo
            valueWidth={"235px"}
            paddingLeft
            title="Detalhes"
            value={`${plan?.description}`}
          />
        </DialogContent>
        <DialogActions>
          <Button color="secondary" onClick={onClose}>
            {"Fechar"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
